'use client';

import {Button as ButtonPrimitive} from '@base-ui/react/button';
import {ChevronDown, ChevronUp, ChevronsUpDown} from 'lucide-react';

import {cn} from '../../lib/utils';

import type {Column} from '@tanstack/react-table';
import type {ReactNode} from 'react';

export interface TableColumnHeaderProps<TData, TValue> {
  column: Column<TData, TValue>;
  title: ReactNode;
  className?: string;
}

export function TableColumnHeader<TData, TValue>({
  column,
  title,
  className
}: TableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <span className={cn(className)}>{title}</span>;
  }

  const sorted = column.getIsSorted();

  return (
    <ButtonPrimitive
      data-slot="table-column-header"
      className={cn('inline-flex items-center gap-1 cursor-pointer', className)}
      onClick={() => column.toggleSorting(sorted === 'asc')}
    >
      {title}
      {sorted === 'asc' ? (
        <ChevronUp className="size-3" />
      ) : sorted === 'desc' ? (
        <ChevronDown className="size-3" />
      ) : (
        <ChevronsUpDown className="size-3" />
      )}
    </ButtonPrimitive>
  );
}
